/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function SalesType(props) {
	const { t } = useTranslation();

	return (
		<BasicCrudScreenType
			id={"SalesType"}
			headerTitle={t("term.salesType")}
			table={"SalesType"}
			view={"VwSalesType"}
			buttonsInFrontOfSearch
		/>
	);
}

export default SalesType;
